import { useEffect } from "react";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import BudgetControlTabs from "./BudgetControlMobileContent/BudgetControlTabs";
import BudgetControlSkel from "./helpers/BudgetControlSkel";
import { useBizDevelopmentDashboardMobile } from "../../../../../../../pages/BizDevelopment/Dashboard/hooks/useBizDevelopmentDashboardMobile";
import MobileFloatingActionButton from "../../../../../../../pages/FloatingItems/MobileFloatingActionButton";

const BudgetControl = () => {
  const [searchParams] = useSearchParams();
  const budgetMobileIsLoading = useSelector(
    (state: any) => state.bizDevelopmentDashboardMobile.budgetMobileIsLoading,
  );
  const { fetchBudgetData, getSiteFromWorkspace } =
    useBizDevelopmentDashboardMobile();
  const workspaceParam = searchParams.get("workspace");

  useEffect(() => {
    const sites = getSiteFromWorkspace();
    if (sites.length === 0) return;
    fetchBudgetData(sites);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceParam]);

  return (
    <>
      <Box sx={{ px: 2, pt: 1 }}>
        {budgetMobileIsLoading ? (
          <BudgetControlSkel />
        ) : (
          <>
            <BudgetControlTabs />
            <MobileFloatingActionButton
              trackerDataId="831"
              saveTrackerDataId="832"
            />
          </>
        )}
      </Box>
    </>
  );
};

export default BudgetControl;
